<template>
  <div class="manageUserTypes">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <addUserDialog @clicked="onClickChild"></addUserDialog>
        <v-spacer></v-spacer>

        <!-- table -->
        <v-flex lg12>
          <v-data-table :headers="headers" :items="userData" class="elevation-1">
            <template v-slot:no-data>
              <v-alert :value="true" color="error" icon="warning">Sorry, nothing to display here :(</v-alert>
            </template>
            <template v-slot:items="props">
              <td class="text-xs-center">{{ props.item.userName }}</td>            
              <td class="justify-center layout px-0">
                <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
                <v-icon small @click="deleteItem(props.item)">delete</v-icon>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import addUserDialog from "../components/AddUserDialog.vue";

export default {
  components: {
    addUserDialog
  },
  methods: {
    onClickChild(value) {
      console.log(value); // someValue
      //alert(JSON.stringify(value));
      this.userData.push(JSON.parse(value));
    },
    deleteItem(value){
      this.userData.pop(value);
    }
  },
  data() {
    return {
      headers: [
        {
          text: "user type",
          align: "center",
          sortable: false,
          value: "userType"
        },
        { text: "Actions", align: "center", value: "action", sortable: false }

      ],
      userData: [
        {
          userName: "asd",
          mobileNumber: "asd",
          city: "",
          branch: "",
          userType: ""
        }
      ]
    };
  }
};
</script>
